module.exports = __webpack_public_path__ + "static/img/empty_nopower.9e67b52e.png";